import React, { useState, useEffect, useCallback } from "react";
import { GrView } from "react-icons/gr";
import { IoPrintOutline } from "react-icons/io5";
import { FaSearch } from "react-icons/fa";
import { getInvoice } from "../../../store/slices/invoiceSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import styles from "./Invoice.module.scss";
import Table from "../../common/Table/table";

const Invoice = () => {
  const {
    invoice,
    searchMessage,
    currentPage,
    totalPages,
    totalCount,
    loading,
  } = useSelector((state) => state.invoice);
  const { token } = useSelector((state) => state.auth);
  const { clinicInfo } = useSelector((state) => state.clinic);
 const clinicId =clinicInfo?.[0]?.clinicId ||null;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [reportFromData, setReportFromData] = useState({
    fromDate: "",
    toDate: "",
  });
  const [pageLimit, setPageLimit] = useState(10);
  const fetchInvoices = useCallback(
    (
      page = 1,
      lim = pageLimit,
      fromDate = reportFromData.fromDate,
      toDate = reportFromData.toDate,
      patientName = ""
    ) => {
      if (clinicId && token) {
        dispatch(
          getInvoice({
            clinicId,
            paymentStatus: ["PAID", "DUE", "UNPAID"],
            fromDate,
            toDate,
            patientName: patientName || undefined,
            currentPage: page,
            limit: lim,
            token,
          })
        );
      }
    },
    [
      clinicId,
      token,
      dispatch,
      reportFromData.fromDate,
      reportFromData.toDate,
      pageLimit,
    ]
  );

  useEffect(() => {
    fetchInvoices();
  }, [fetchInvoices]);
  const handlePageChange = (page) => {
    fetchInvoices(page, pageLimit);
  };
  const handleLimitChange = (newLimit) => {
    setPageLimit(newLimit);
    fetchInvoices(1, newLimit);
  };
  const handleFilter = () => {
    fetchInvoices(1, pageLimit);
  };

  const handleEdit = (invoiceId) => {
    navigate(`/invoice-form`);
    sessionStorage.setItem("invoiceId", invoiceId?.id);
  };

  // const handlePrint = (invoiceId) => {
  //   navigate(`/view_invoice`);
  //   sessionStorage.setItem("invoiceId", invoiceId?.id);
  // };
    const handlePrint = (invoiceId) => {
    navigate(`/invoice-report-pdf`);
    sessionStorage.setItem("invoiceId", invoiceId?.id);
  };

  const MyCollection = () => {
    navigate(`/myCollection`);
  };
  const handleSearchChange = (e) => {
    const patientName = e.target.value;
    fetchInvoices(
      1,
      pageLimit,
      reportFromData.fromDate,
      reportFromData.toDate,
      patientName
    );
  };

  const handleClear = useCallback(() => {
    setReportFromData({ fromDate: "", toDate: "" });
    fetchInvoices(1, pageLimit);
  }, [fetchInvoices, pageLimit]);

  const tableHead = [
    { title: "InvId", key: "invId" },
    { title: "Patient Name", key: "name" },
    { title: "ApptId", key: "apptId" },
    { title: "Appt Date", key: "apptDate" },
    { title: "Status", key: "status" },
    { title: "Amount", key: "amount" },
    { title: "Mode", key: "mode" },
  ];
  return (
    <>
      <div className="row">
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">From</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.fromDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    fromDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
        <div className="col-md-2">
          <div className="form-group form-focus focused">
            <label className="focus-label">To</label>
            <div className="cal-icon">
              <input
                className="form-control floating datetimepicker"
                type="date"
                value={reportFromData.toDate}
                onChange={(e) =>
                  setReportFromData({
                    ...reportFromData,
                    toDate: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="col-md-3 mt-2">
          <button className="btn btn-primary mt-3" onClick={handleFilter}>
            Filter
          </button>
          <button className="btn btn-danger mt-3 ms-3" onClick={handleClear}>
            Clear
          </button>
        </div>

        <div className="col-md-2 mt-4">
          <button className="btn btn-primary" onClick={() => MyCollection()}>
            My Collection
          </button>
        </div>

        <div className={classNames("col-md-3", "mt-4", styles["search-area"])}>
          <input
            type="text"
            className={classNames("form-control", styles["search-input"])}
            placeholder="Search here"
            onChange={handleSearchChange}
          />
          <div className="input-group-append">
            <FaSearch className="flaticon-381-search-2" />
          </div>
        </div>
      </div>

      <Table
        tableHead={tableHead}
        tableBody={
          Array.isArray(invoice)
            ? invoice?.map((item) => ({
                id: item?._id,
                invId: item?.invoiceId || "N/A",
                name: item?.appointmentDetails?.patientName || "N/A",
                apptId: item?.appointmentDetails?.appointmentId || "N/A",
                apptDate:
                  item?.appointmentDetails?.appDate?.split("T")[0] || "N/A",
                status: item?.paymentStatus || "N/A",
                amount: item?.totalAmount || "N/A",
                mode: item?.receiptId?.accountType?.name || "N/A",
              }))
            : []
        }
        errorMessage={searchMessage}
        handleEdit={handleEdit}
        handlePrint={handlePrint}
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        limit={pageLimit}
        onPageChange={handlePageChange}
        onLimitChange={handleLimitChange}
        showPagination={true}
        showLimitDropdown={true}
        isLoading={loading}
      />
      <invoiceForm />
    </>
  );
};

export default Invoice;
